// Importing action types and initial state
import * as types from "../Actions/ActionTypes";
import initialState from "./initailState";

// Reducer function to manage payment-related state
const paymentReducer = (state = initialState.payment, action) => {
  switch (action.type) {
    // Handle setting checkout data
    case types.SET_CHECKOUT_DATA:
      return { ...state, data: action.data };

    // Default case to return the current state
    default:
      return state;
  }
};

// Exporting the reducer as the default export
export default paymentReducer;
